// Book Whispers — Your Turn :: i18n bundle (10 languages)
// Self-contained translation file used only by BookWhispersSection.jsx

const bookWhispersTranslations = {
  en: {
    sectionTitle: "Book Whispers",
    sectionSubtitle: "Your Turn.",
    sectionTagline: "The best books are not just read — they are lived and shared.",
    cta: "Whisper a Book",
    modal: {
      leftHeading: "Which book stayed with you?",
      searchPlaceholder: "Title, author, or ISBN…",
      searchHint: "Or describe it and we'll help find it",
      uploadLabel: "Upload the cover",
      uploadHint: "If you have a photo of the book",
      uploadCta: "Choose a photo",
      uploadedPrefix: "Cover attached:",
      uploadRemove: "Remove",
      uploadTooLarge: "Image is too large. Please use a photo under 2 MB.",

      rightHeading: "Tell us why it stayed with you",
      micLabel: "Speak Your Reflection",
      micHint: "Tap to record. We'll transcribe it for you.",
      micListening: "Listening…",
      micUnsupported: "Voice input isn't supported in this browser. Please type your reflection.",

      textAreaLabel: "Edit or add to your reflection",
      textAreaPlaceholder: "Or write your reflection here…",

      nameLabel: "Your name",
      namePlaceholder: "Your name, if you wish to be known",

      submit: "Seal & Send",
      submitting: "Sealing…",
      submitErrorEmpty: "Please share a few words about why this book stayed with you.",
      submitErrorGeneric: "Something went wrong. Please try again.",
      bottomTagline: "Knowledge shared is wisdom multiplied.",
      close: "Close",
    },
    confirmation: {
      heading: "Your Whisper has been sealed.",
      subtitle: "We'll read it with care. Thank you for sharing what moved you.",
      signoff: "— The iCraftz Library",
    },
  },

  hi: {
    sectionTitle: "पुस्तक फुसफुसाहट",
    sectionSubtitle: "अब आपकी बारी।",
    sectionTagline: "सर्वश्रेष्ठ किताबें केवल पढ़ी नहीं जातीं — उन्हें जिया और साझा किया जाता है।",
    cta: "एक किताब फुसफुसाएं",
    modal: {
      leftHeading: "कौन सी किताब आपके साथ रह गई?",
      searchPlaceholder: "शीर्षक, लेखक या ISBN…",
      searchHint: "या इसे वर्णित करें, हम ढूंढ़ने में मदद करेंगे",
      uploadLabel: "कवर अपलोड करें",
      uploadHint: "यदि आपके पास किताब की तस्वीर है",
      uploadCta: "तस्वीर चुनें",
      uploadedPrefix: "कवर संलग्न:",
      uploadRemove: "हटाएं",
      uploadTooLarge: "छवि बहुत बड़ी है। कृपया 2 MB से छोटी तस्वीर का उपयोग करें।",
      rightHeading: "हमें बताइए यह क्यों यादगार रही",
      micLabel: "अपना विचार बोलें",
      micHint: "रिकॉर्ड करने के लिए टैप करें। हम लिख लेंगे।",
      micListening: "सुन रहे हैं…",
      micUnsupported: "इस ब्राउज़र में आवाज़ इनपुट उपलब्ध नहीं है। कृपया लिखकर साझा करें।",
      textAreaLabel: "अपने विचार में बदलाव या जोड़ करें",
      textAreaPlaceholder: "या अपने विचार यहाँ लिखें…",
      nameLabel: "आपका नाम",
      namePlaceholder: "यदि आप पहचाने जाना चाहें, अपना नाम लिखें",
      submit: "मुहर लगाकर भेजें",
      submitting: "भेजा जा रहा है…",
      submitErrorEmpty: "कृपया कुछ शब्दों में बताइए यह किताब क्यों यादगार रही।",
      submitErrorGeneric: "कुछ गलत हुआ। कृपया फिर कोशिश करें।",
      bottomTagline: "साझा किया गया ज्ञान, विवेक को कई गुना करता है।",
      close: "बंद करें",
    },
    confirmation: {
      heading: "आपकी फुसफुसाहट मुहरबंद हो गई है।",
      subtitle: "हम इसे ध्यान से पढ़ेंगे। साझा करने के लिए धन्यवाद।",
      signoff: "— iCraftz पुस्तकालय",
    },
  },

  te: {
    sectionTitle: "పుస్తక గుసగుసలు",
    sectionSubtitle: "మీ వంతు.",
    sectionTagline: "ఉత్తమ పుస్తకాలు చదవడానికే కాదు — అవి జీవించబడతాయి, పంచుకోబడతాయి.",
    cta: "ఒక పుస్తకాన్ని గుసగుసలాడండి",
    modal: {
      leftHeading: "ఏ పుస్తకం మీతో మిగిలిపోయింది?",
      searchPlaceholder: "శీర్షిక, రచయిత లేదా ISBN…",
      searchHint: "లేదా వివరించండి, మేము కనుగొనడంలో సహాయపడతాం",
      uploadLabel: "కవర్‌ను అప్‌లోడ్ చేయండి",
      uploadHint: "మీ వద్ద పుస్తకం ఫోటో ఉంటే",
      uploadCta: "ఒక ఫోటోను ఎంచుకోండి",
      uploadedPrefix: "కవర్ జతచేయబడింది:",
      uploadRemove: "తొలగించు",
      uploadTooLarge: "చిత్రం చాలా పెద్దది. దయచేసి 2 MB కన్నా చిన్న ఫోటోను ఉపయోగించండి.",
      rightHeading: "ఇది ఎందుకు మిగిలిపోయిందో మాకు చెప్పండి",
      micLabel: "మీ ప్రతిబింబాన్ని మాట్లాడండి",
      micHint: "రికార్డ్ చేయడానికి నొక్కండి. మేము లిప్యంతరం చేస్తాము.",
      micListening: "వింటున్నాము…",
      micUnsupported: "ఈ బ్రౌజర్‌లో వాయిస్ ఇన్‌పుట్ మద్దతు లేదు. దయచేసి టైప్ చేయండి.",
      textAreaLabel: "మీ ప్రతిబింబాన్ని సవరించండి లేదా జోడించండి",
      textAreaPlaceholder: "లేదా మీ ప్రతిబింబాన్ని ఇక్కడ రాయండి…",
      nameLabel: "మీ పేరు",
      namePlaceholder: "మీరు తెలియాలనుకుంటే, మీ పేరు",
      submit: "ముద్ర వేసి పంపు",
      submitting: "పంపుతున్నాము…",
      submitErrorEmpty: "ఈ పుస్తకం ఎందుకు మిగిలిపోయిందో కొన్ని మాటలతో పంచుకోండి.",
      submitErrorGeneric: "ఏదో తప్పు జరిగింది. దయచేసి మళ్లీ ప్రయత్నించండి.",
      bottomTagline: "పంచిన జ్ఞానం వివేకాన్ని గుణిస్తుంది.",
      close: "మూసివేయి",
    },
    confirmation: {
      heading: "మీ గుసగుస ముద్ర వేయబడింది.",
      subtitle: "మేము జాగ్రత్తగా చదువుతాము. మీరు పంచుకున్నందుకు ధన్యవాదాలు.",
      signoff: "— iCraftz గ్రంథాలయం",
    },
  },

  ta: {
    sectionTitle: "புத்தகக் கிசுகிசுப்பு",
    sectionSubtitle: "உங்கள் முறை.",
    sectionTagline: "சிறந்த புத்தகங்கள் வாசிக்கப்படுவது மட்டுமல்ல — அவை வாழப்படுகின்றன, பகிரப்படுகின்றன.",
    cta: "ஒரு புத்தகத்தை கிசுகிசுங்கள்",
    modal: {
      leftHeading: "எந்த புத்தகம் உங்களுடன் தங்கியிருந்தது?",
      searchPlaceholder: "தலைப்பு, எழுத்தாளர் அல்லது ISBN…",
      searchHint: "அல்லது விவரியுங்கள், நாங்கள் கண்டுபிடிக்க உதவுவோம்",
      uploadLabel: "அட்டையைப் பதிவேற்றுக",
      uploadHint: "உங்களிடம் புத்தகத்தின் புகைப்படம் இருந்தால்",
      uploadCta: "ஒரு புகைப்படத்தைத் தேர்வுசெய்க",
      uploadedPrefix: "அட்டை இணைக்கப்பட்டது:",
      uploadRemove: "அகற்று",
      uploadTooLarge: "படம் மிகப் பெரியது. 2 MB-க்குக் குறைவான புகைப்படத்தைப் பயன்படுத்துக.",
      rightHeading: "ஏன் இது உங்களுடன் தங்கியது என்று சொல்லுங்கள்",
      micLabel: "உங்கள் பிரதிபலிப்பைப் பேசுங்கள்",
      micHint: "பதிவுசெய்ய தட்டுங்கள். நாங்கள் எழுத்தாக மாற்றுவோம்.",
      micListening: "கேட்கிறோம்…",
      micUnsupported: "இந்த உலாவியில் குரல் உள்ளீடு இல்லை. தயவு செய்து தட்டச்சு செய்க.",
      textAreaLabel: "உங்கள் பிரதிபலிப்பைத் திருத்து அல்லது சேர்க்கவும்",
      textAreaPlaceholder: "அல்லது இங்கே எழுதுங்கள்…",
      nameLabel: "உங்கள் பெயர்",
      namePlaceholder: "நீங்கள் அறியப்பட விரும்பினால், உங்கள் பெயர்",
      submit: "முத்திரையிட்டு அனுப்பு",
      submitting: "அனுப்புகிறோம்…",
      submitErrorEmpty: "ஏன் இது உங்களுடன் தங்கியது என்று சில வார்த்தைகளில் பகிருங்கள்.",
      submitErrorGeneric: "ஏதோ தவறு. மீண்டும் முயற்சிக்கவும்.",
      bottomTagline: "பகிரப்படும் அறிவு ஞானத்தைப் பெருக்குகிறது.",
      close: "மூடு",
    },
    confirmation: {
      heading: "உங்கள் கிசுகிசுப்பு முத்திரையிடப்பட்டது.",
      subtitle: "நாங்கள் அதை கவனமாக வாசிப்போம். பகிர்ந்ததற்கு நன்றி.",
      signoff: "— iCraftz நூலகம்",
    },
  },

  kn: {
    sectionTitle: "ಪುಸ್ತಕ ಗುಸುಗುಸು",
    sectionSubtitle: "ನಿಮ್ಮ ಸರದಿ.",
    sectionTagline: "ಉತ್ತಮ ಪುಸ್ತಕಗಳನ್ನು ಕೇವಲ ಓದುವುದಿಲ್ಲ — ಅವುಗಳನ್ನು ಜೀವಿಸಲಾಗುತ್ತದೆ, ಹಂಚಿಕೊಳ್ಳಲಾಗುತ್ತದೆ.",
    cta: "ಪುಸ್ತಕವೊಂದನ್ನು ಗುಸುಗುಸುಗೊಳಿಸಿ",
    modal: {
      leftHeading: "ಯಾವ ಪುಸ್ತಕ ನಿಮ್ಮೊಂದಿಗೆ ಉಳಿಯಿತು?",
      searchPlaceholder: "ಶೀರ್ಷಿಕೆ, ಲೇಖಕ ಅಥವಾ ISBN…",
      searchHint: "ಅಥವಾ ವಿವರಿಸಿ, ನಾವು ಹುಡುಕಲು ಸಹಾಯ ಮಾಡುತ್ತೇವೆ",
      uploadLabel: "ಮುಖಪುಟವನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
      uploadHint: "ಪುಸ್ತಕದ ಚಿತ್ರ ಇದ್ದರೆ",
      uploadCta: "ಚಿತ್ರ ಆಯ್ಕೆಮಾಡಿ",
      uploadedPrefix: "ಮುಖಪುಟ ಲಗತ್ತಿಸಲಾಗಿದೆ:",
      uploadRemove: "ತೆಗೆದುಹಾಕು",
      uploadTooLarge: "ಚಿತ್ರ ತುಂಬಾ ದೊಡ್ಡದಾಗಿದೆ. ದಯವಿಟ್ಟು 2 MB ಗಿಂತ ಕಡಿಮೆ ಬಳಸಿ.",
      rightHeading: "ಇದು ಏಕೆ ಉಳಿಯಿತು ಎಂದು ತಿಳಿಸಿ",
      micLabel: "ನಿಮ್ಮ ಪ್ರತಿಬಿಂಬವನ್ನು ಮಾತನಾಡಿ",
      micHint: "ರೆಕಾರ್ಡ್ ಮಾಡಲು ಒತ್ತಿ. ನಾವು ಲಿಪ್ಯಂತರಿಸುತ್ತೇವೆ.",
      micListening: "ಕೇಳುತ್ತಿದ್ದೇವೆ…",
      micUnsupported: "ಈ ಬ್ರೌಸರ್‌ನಲ್ಲಿ ಧ್ವನಿ ಇನ್‌ಪುಟ್ ಬೆಂಬಲಿತವಲ್ಲ. ದಯವಿಟ್ಟು ಟೈಪ್ ಮಾಡಿ.",
      textAreaLabel: "ನಿಮ್ಮ ಪ್ರತಿಬಿಂಬವನ್ನು ಸಂಪಾದಿಸಿ ಅಥವಾ ಸೇರಿಸಿ",
      textAreaPlaceholder: "ಅಥವಾ ಇಲ್ಲಿ ಬರೆಯಿರಿ…",
      nameLabel: "ನಿಮ್ಮ ಹೆಸರು",
      namePlaceholder: "ನೀವು ಪರಿಚಿತರಾಗಲು ಬಯಸಿದರೆ, ನಿಮ್ಮ ಹೆಸರು",
      submit: "ಮುದ್ರೆ ಒತ್ತಿ ಕಳುಹಿಸಿ",
      submitting: "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ…",
      submitErrorEmpty: "ಈ ಪುಸ್ತಕ ಏಕೆ ಉಳಿಯಿತು ಎಂದು ಕೆಲ ಪದಗಳಲ್ಲಿ ಹಂಚಿಕೊಳ್ಳಿ.",
      submitErrorGeneric: "ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
      bottomTagline: "ಹಂಚಿದ ಜ್ಞಾನ ವಿವೇಕವನ್ನು ಗುಣಿಸುತ್ತದೆ.",
      close: "ಮುಚ್ಚು",
    },
    confirmation: {
      heading: "ನಿಮ್ಮ ಗುಸುಗುಸು ಮುದ್ರೆಯಾಗಿದೆ.",
      subtitle: "ನಾವು ಜಾಗ್ರತೆಯಿಂದ ಓದುತ್ತೇವೆ. ಹಂಚಿಕೊಂಡಿದ್ದಕ್ಕೆ ಧನ್ಯವಾದಗಳು.",
      signoff: "— iCraftz ಗ್ರಂಥಾಲಯ",
    },
  },

  mr: {
    sectionTitle: "पुस्तक कुजबुज",
    sectionSubtitle: "आता तुमची पाळी.",
    sectionTagline: "उत्तम पुस्तके केवळ वाचली जात नाहीत — ती जगली आणि वाटली जातात.",
    cta: "एक पुस्तक कुजबुजा",
    modal: {
      leftHeading: "कोणते पुस्तक तुमच्यासोबत राहिले?",
      searchPlaceholder: "शीर्षक, लेखक किंवा ISBN…",
      searchHint: "किंवा वर्णन करा, आम्ही शोधण्यात मदत करू",
      uploadLabel: "कव्हर अपलोड करा",
      uploadHint: "जर पुस्तकाचा फोटो असेल",
      uploadCta: "फोटो निवडा",
      uploadedPrefix: "कव्हर जोडले:",
      uploadRemove: "काढा",
      uploadTooLarge: "प्रतिमा खूप मोठी आहे. कृपया 2 MB पेक्षा कमी वापरा.",
      rightHeading: "हे का राहिले ते सांगा",
      micLabel: "तुमचे विचार बोला",
      micHint: "रेकॉर्ड करण्यासाठी टॅप करा. आम्ही लिहून घेतो.",
      micListening: "ऐकत आहोत…",
      micUnsupported: "या ब्राउजरमध्ये आवाज इनपुट नाही. कृपया लिहा.",
      textAreaLabel: "तुमचे विचार संपादित करा किंवा जोडा",
      textAreaPlaceholder: "किंवा येथे लिहा…",
      nameLabel: "तुमचे नाव",
      namePlaceholder: "तुम्हाला ओळखले जायचे असल्यास, तुमचे नाव",
      submit: "शिक्का मारून पाठवा",
      submitting: "पाठवत आहोत…",
      submitErrorEmpty: "हे पुस्तक का राहिले ते थोडक्यात सांगा.",
      submitErrorGeneric: "काहीतरी चुकले. कृपया पुन्हा प्रयत्न करा.",
      bottomTagline: "वाटून दिलेले ज्ञान विवेक वाढवते.",
      close: "बंद करा",
    },
    confirmation: {
      heading: "तुमची कुजबुज शिक्कामोर्तब झाली.",
      subtitle: "आम्ही ते काळजीपूर्वक वाचू. तुम्ही वाटून दिल्याबद्दल धन्यवाद.",
      signoff: "— iCraftz ग्रंथालय",
    },
  },

  bn: {
    sectionTitle: "বইয়ের ফিসফিস",
    sectionSubtitle: "এবার আপনার পালা।",
    sectionTagline: "সেরা বইগুলো শুধু পড়া হয় না — সেগুলো বাঁচানো হয় ও ভাগ করা হয়।",
    cta: "একটি বই ফিসফিস করুন",
    modal: {
      leftHeading: "কোন বই আপনার সাথে থেকে গেছে?",
      searchPlaceholder: "শিরোনাম, লেখক বা ISBN…",
      searchHint: "অথবা বর্ণনা দিন, আমরা খুঁজে দেব",
      uploadLabel: "প্রচ্ছদ আপলোড করুন",
      uploadHint: "যদি বইয়ের ছবি থাকে",
      uploadCta: "একটি ছবি বেছে নিন",
      uploadedPrefix: "প্রচ্ছদ যুক্ত:",
      uploadRemove: "সরান",
      uploadTooLarge: "ছবিটি খুব বড়। দয়া করে 2 MB-এর কম ব্যবহার করুন.",
      rightHeading: "কেন এটি থেকে গেছে আমাদের বলুন",
      micLabel: "আপনার ভাবনা বলুন",
      micHint: "রেকর্ড করতে ট্যাপ করুন। আমরা লিখে নেব।",
      micListening: "শুনছি…",
      micUnsupported: "এই ব্রাউজারে কণ্ঠস্বর সমর্থিত নয়। দয়া করে টাইপ করুন।",
      textAreaLabel: "আপনার ভাবনা সম্পাদনা বা যোগ করুন",
      textAreaPlaceholder: "অথবা এখানে লিখুন…",
      nameLabel: "আপনার নাম",
      namePlaceholder: "যদি পরিচিত হতে চান, আপনার নাম",
      submit: "সিল করে পাঠান",
      submitting: "পাঠাচ্ছি…",
      submitErrorEmpty: "এই বই কেন থেকে গেছে কয়েকটি শব্দে শেয়ার করুন।",
      submitErrorGeneric: "কিছু ভুল হয়েছে। দয়া করে আবার চেষ্টা করুন।",
      bottomTagline: "ভাগ করা জ্ঞান প্রজ্ঞাকে বাড়িয়ে তোলে।",
      close: "বন্ধ করুন",
    },
    confirmation: {
      heading: "আপনার ফিসফিস সিল করা হয়েছে।",
      subtitle: "আমরা যত্ন করে পড়ব। ভাগ করার জন্য ধন্যবাদ।",
      signoff: "— iCraftz গ্রন্থাগার",
    },
  },

  gu: {
    sectionTitle: "પુસ્તક ગૂસપૂસ",
    sectionSubtitle: "હવે તમારો વારો.",
    sectionTagline: "શ્રેષ્ઠ પુસ્તકો ફક્ત વાંચાતા નથી — તે જીવાય છે અને વહેંચાય છે.",
    cta: "એક પુસ્તકની ગૂસપૂસ કરો",
    modal: {
      leftHeading: "કયું પુસ્તક તમારી સાથે રહ્યું?",
      searchPlaceholder: "શીર્ષક, લેખક અથવા ISBN…",
      searchHint: "અથવા વર્ણન કરો, અમે શોધવામાં મદદ કરીશું",
      uploadLabel: "કવર અપલોડ કરો",
      uploadHint: "જો પુસ્તકનો ફોટો હોય",
      uploadCta: "ફોટો પસંદ કરો",
      uploadedPrefix: "કવર જોડાયું:",
      uploadRemove: "દૂર કરો",
      uploadTooLarge: "છબી ખૂબ મોટી છે. કૃપા કરી 2 MB કરતાં ઓછી વાપરો.",
      rightHeading: "આ કેમ રહ્યું તે કહો",
      micLabel: "તમારા વિચાર બોલો",
      micHint: "રેકોર્ડ કરવા ટેપ કરો. અમે લખી લઈશું.",
      micListening: "સાંભળી રહ્યા છીએ…",
      micUnsupported: "આ બ્રાઉઝરમાં અવાજ ઈનપુટ ઉપલબ્ધ નથી. કૃપા કરી ટાઇપ કરો.",
      textAreaLabel: "તમારા વિચાર સંપાદિત કરો અથવા ઉમેરો",
      textAreaPlaceholder: "અથવા અહીં લખો…",
      nameLabel: "તમારું નામ",
      namePlaceholder: "જો જાણીતા થવા માગો, તમારું નામ",
      submit: "મુદ્રા લગાવી મોકલો",
      submitting: "મોકલી રહ્યા છીએ…",
      submitErrorEmpty: "આ પુસ્તક કેમ રહ્યું તે થોડા શબ્દોમાં વહેંચો.",
      submitErrorGeneric: "કશું ખોટું થયું. કૃપા કરી ફરી પ્રયત્ન કરો.",
      bottomTagline: "વહેંચેલું જ્ઞાન બુદ્ધિને ગુણાકાર કરે છે.",
      close: "બંધ કરો",
    },
    confirmation: {
      heading: "તમારી ગૂસપૂસ મુદ્રિત થઈ.",
      subtitle: "અમે ધ્યાનથી વાંચીશું. વહેંચવા બદલ આભાર.",
      signoff: "— iCraftz પુસ્તકાલય",
    },
  },

  ml: {
    sectionTitle: "പുസ്തക മന്ത്രണം",
    sectionSubtitle: "ഇപ്പോൾ നിങ്ങളുടെ ഊഴം.",
    sectionTagline: "നല്ല പുസ്തകങ്ങൾ വായിക്കാൻ മാത്രമല്ല — അവ ജീവിക്കാനും പങ്കിടാനും ഉള്ളവ.",
    cta: "ഒരു പുസ്തകം മന്ത്രിക്കുക",
    modal: {
      leftHeading: "ഏത് പുസ്തകം നിങ്ങളോടൊപ്പം നിന്നു?",
      searchPlaceholder: "തലക്കെട്ട്, എഴുത്തുകാരൻ അല്ലെങ്കിൽ ISBN…",
      searchHint: "അല്ലെങ്കിൽ വിവരിക്കുക, ഞങ്ങൾ കണ്ടെത്താൻ സഹായിക്കാം",
      uploadLabel: "കവർ അപ്‌ലോഡ് ചെയ്യുക",
      uploadHint: "പുസ്തകത്തിന്റെ ഫോട്ടോ ഉണ്ടെങ്കിൽ",
      uploadCta: "ഫോട്ടോ തിരഞ്ഞെടുക്കുക",
      uploadedPrefix: "കവർ ചേർത്തു:",
      uploadRemove: "നീക്കം ചെയ്യുക",
      uploadTooLarge: "ചിത്രം വളരെ വലുതാണ്. 2 MB-ൽ താഴെ ഉപയോഗിക്കുക.",
      rightHeading: "എന്തുകൊണ്ട് ഇത് നിലനിന്നുവെന്ന് പറയുക",
      micLabel: "നിങ്ങളുടെ പ്രതിഫലനം പറയുക",
      micHint: "റെക്കോർഡുചെയ്യാൻ ടാപ്പുചെയ്യുക. ഞങ്ങൾ ലിപ്യന്തരണം ചെയ്യും.",
      micListening: "കേൾക്കുന്നു…",
      micUnsupported: "ഈ ബ്രൗസറിൽ ശബ്ദ ഇൻപുട്ട് ഇല്ല. ദയവായി ടൈപ്പ് ചെയ്യുക.",
      textAreaLabel: "നിങ്ങളുടെ പ്രതിഫലനം എഡിറ്റ് ചെയ്യുക അല്ലെങ്കിൽ ചേർക്കുക",
      textAreaPlaceholder: "അല്ലെങ്കിൽ ഇവിടെ എഴുതുക…",
      nameLabel: "നിങ്ങളുടെ പേര്",
      namePlaceholder: "അറിയപ്പെടണമെങ്കിൽ, നിങ്ങളുടെ പേര്",
      submit: "സീൽ ചെയ്ത് അയയ്ക്കുക",
      submitting: "അയയ്ക്കുന്നു…",
      submitErrorEmpty: "എന്തുകൊണ്ട് ഇത് നിലനിന്നു എന്ന് കുറച്ച് വാക്കുകളിൽ പങ്കിടുക.",
      submitErrorGeneric: "എന്തോ പിശക്. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
      bottomTagline: "പങ്കിട്ട അറിവ് വിവേകത്തെ വർദ്ധിപ്പിക്കുന്നു.",
      close: "അടയ്ക്കുക",
    },
    confirmation: {
      heading: "നിങ്ങളുടെ മന്ത്രണം മുദ്രവെച്ചു.",
      subtitle: "ഞങ്ങൾ ശ്രദ്ധയോടെ വായിക്കും. പങ്കിട്ടതിന് നന്ദി.",
      signoff: "— iCraftz ഗ്രന്ഥശാല",
    },
  },

  pa: {
    sectionTitle: "ਕਿਤਾਬ ਘੁਸਰ-ਮੁਸਰ",
    sectionSubtitle: "ਹੁਣ ਤੁਹਾਡੀ ਵਾਰੀ.",
    sectionTagline: "ਵਧੀਆ ਕਿਤਾਬਾਂ ਸਿਰਫ਼ ਪੜ੍ਹੀਆਂ ਨਹੀਂ ਜਾਂਦੀਆਂ — ਉਹ ਜੀਵੀਆਂ ਅਤੇ ਸਾਂਝੀਆਂ ਕੀਤੀਆਂ ਜਾਂਦੀਆਂ ਹਨ।",
    cta: "ਇੱਕ ਕਿਤਾਬ ਬਾਰੇ ਫੁਸਫੁਸਾਓ",
    modal: {
      leftHeading: "ਕਿਹੜੀ ਕਿਤਾਬ ਤੁਹਾਡੇ ਨਾਲ ਰਹਿ ਗਈ?",
      searchPlaceholder: "ਸਿਰਲੇਖ, ਲੇਖਕ ਜਾਂ ISBN…",
      searchHint: "ਜਾਂ ਵਰਣਨ ਕਰੋ, ਅਸੀਂ ਲੱਭਣ ਵਿੱਚ ਮਦਦ ਕਰਾਂਗੇ",
      uploadLabel: "ਕਵਰ ਅੱਪਲੋਡ ਕਰੋ",
      uploadHint: "ਜੇ ਕਿਤਾਬ ਦੀ ਫੋਟੋ ਹੈ",
      uploadCta: "ਇੱਕ ਫੋਟੋ ਚੁਣੋ",
      uploadedPrefix: "ਕਵਰ ਨੱਥੀ:",
      uploadRemove: "ਹਟਾਓ",
      uploadTooLarge: "ਤਸਵੀਰ ਬਹੁਤ ਵੱਡੀ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ 2 MB ਤੋਂ ਘੱਟ ਵਰਤੋ।",
      rightHeading: "ਇਹ ਕਿਉਂ ਯਾਦ ਰਹੀ ਸਾਨੂੰ ਦੱਸੋ",
      micLabel: "ਆਪਣੀ ਪ੍ਰਤੀਬਿੰਬਨਾ ਬੋਲੋ",
      micHint: "ਰਿਕਾਰਡ ਕਰਨ ਲਈ ਟੈਪ ਕਰੋ। ਅਸੀਂ ਲਿਖ ਲਵਾਂਗੇ।",
      micListening: "ਸੁਣ ਰਹੇ ਹਾਂ…",
      micUnsupported: "ਇਸ ਬ੍ਰਾਊਜ਼ਰ ਵਿੱਚ ਆਵਾਜ਼ ਇਨਪੁਟ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਟਾਈਪ ਕਰੋ।",
      textAreaLabel: "ਆਪਣੀ ਪ੍ਰਤੀਬਿੰਬਨਾ ਨੂੰ ਸੋਧੋ ਜਾਂ ਜੋੜੋ",
      textAreaPlaceholder: "ਜਾਂ ਇੱਥੇ ਲਿਖੋ…",
      nameLabel: "ਤੁਹਾਡਾ ਨਾਮ",
      namePlaceholder: "ਜੇ ਤੁਸੀਂ ਜਾਣੇ ਜਾਣਾ ਚਾਹੁੰਦੇ ਹੋ, ਤੁਹਾਡਾ ਨਾਮ",
      submit: "ਸੀਲ ਕਰਕੇ ਭੇਜੋ",
      submitting: "ਭੇਜ ਰਹੇ ਹਾਂ…",
      submitErrorEmpty: "ਇਹ ਕਿਤਾਬ ਕਿਉਂ ਯਾਦ ਰਹੀ ਥੋੜ੍ਹੇ ਸ਼ਬਦਾਂ ਵਿੱਚ ਸਾਂਝਾ ਕਰੋ।",
      submitErrorGeneric: "ਕੁਝ ਗਲਤ ਹੋਇਆ। ਕਿਰਪਾ ਕਰਕੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
      bottomTagline: "ਸਾਂਝਾ ਕੀਤਾ ਗਿਆਨ ਬੁੱਧ ਨੂੰ ਗੁਣਾ ਕਰਦਾ ਹੈ।",
      close: "ਬੰਦ ਕਰੋ",
    },
    confirmation: {
      heading: "ਤੁਹਾਡੀ ਫੁਸਫੁਸਾਹਟ ਮੁਹਰਬੰਦ ਹੋ ਗਈ।",
      subtitle: "ਅਸੀਂ ਧਿਆਨ ਨਾਲ ਪੜ੍ਹਾਂਗੇ। ਸਾਂਝਾ ਕਰਨ ਲਈ ਧੰਨਵਾਦ।",
      signoff: "— iCraftz ਲਾਇਬ੍ਰੇਰੀ",
    },
  },
};

export default bookWhispersTranslations;
